import { useEffect } from "react";
import { SelectControl } from "wvus-forms";

/**
 * Select component for rendering a select dropdown field
 *
 * @param {Object} props.formMethods - Methods for handling form state and validation
 * @param {string} props.items - items for the select dropdown
 * @param {Object} props.fieldAttributes - The attributes for the select field such as fieldName, fieldValue, etc.
 *
 * @returns {JSX.Element} The rendered Select component.
 */
const Select = ({ formMethods, items = [], fieldAttributes }) => {
  const { fieldName } = fieldAttributes;
  const { getFormState } = formMethods;
  const formFields = getFormState().fields;

  useEffect(() => {
    if (fieldAttributes.fieldValue) {
      formMethods.setValueChange(fieldName, fieldAttributes.fieldValue);
    }
    // do not add to dep array as the dependency on wvus-forms and watching this would cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SelectControl
        {...fieldAttributes}
        formMethods={formMethods}
        fieldValue={fieldAttributes.fieldValue || formFields[fieldName]?.value}
        fieldOptions={items}
      />
      {fieldAttributes.descriptionText && (
        <p className="micro sub-text">{fieldAttributes.descriptionText}</p>
      )}
    </>
  );
};

export default Select;
